import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const NewFAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'Was kostet eine Sterbegeldversicherung monatlich?',
      answer: 'Die monatlichen Beiträge hängen von Ihrem Alter und der gewünschten Versicherungssumme ab. Typischerweise liegen die Beiträge zwischen 15 € und 50 € pro Monat. Je früher Sie beginnen, desto günstiger ist der Beitrag. In einem kostenlosen Beratungsgespräch erstellen wir Ihnen ein individuelles Angebot.'
    },
    {
      question: 'Gibt es eine Gesundheitsprüfung?',
      answer: 'Nein, bei den meisten Sterbegeldversicherungen ist keine ärztliche Untersuchung oder Gesundheitsprüfung erforderlich. Lediglich wenige Gesundheitsfragen werden gestellt. Das macht den Abschluss besonders einfach und unkompliziert – unabhängig von Vorerkrankungen.'
    },
    {
      question: 'Gibt es eine Wartezeit nach Vertragsabschluss?',
      answer: 'Ja, die meisten Sterbegeldversicherungen haben eine Wartezeit von 12 bis 36 Monaten. Das bedeutet: Bei Tod durch Krankheit in dieser Zeit wird oft nur die Beitragsrückzahlung geleistet. Bei Unfalltod gilt der volle Versicherungsschutz sofort. Nach Ablauf der Wartezeit greift der vollständige Schutz.'
    },
    {
      question: 'Kann ich die Versicherung kündigen?',
      answer: 'Ja, Sie können Ihre Sterbegeldversicherung jederzeit kündigen. Bei den meisten Tarifen erhalten Sie nach mehrjähriger Vertragslaufzeit einen Teil der eingezahlten Beiträge zurück (Rückkaufswert). Wir empfehlen jedoch, die Versicherung beizubehalten, da sie Ihre Familie langfristig absichert.'
    },
    {
      question: 'Wer bekommt die Versicherungssumme ausgezahlt?',
      answer: 'Sie bestimmen selbst, wer die Versicherungssumme im Todesfall erhält – beispielsweise Ihre Angehörigen, ein Bestatter oder eine andere Person Ihres Vertrauens. Die Auszahlung erfolgt schnell und unkompliziert, damit die Bestattungskosten sofort beglichen werden können.'
    },
    {
      question: 'Ab welchem Alter kann ich abschließen?',
      answer: 'Eine Sterbegeldversicherung können Sie in der Regel ab 35 Jahren abschließen. Viele Versicherer bieten Tarife bis zu einem Alter von 85 Jahren an. Je früher Sie beginnen, desto niedriger sind die monatlichen Beiträge und desto länger profitieren Sie vom Versicherungsschutz.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="section faq-section-new">
      <div className="container-custom">
        <div className="section-header fade-in">
          <h2 className="headline-secondary">Häufige Fragen zur Sterbegeldversicherung</h2>
        </div>

        <div className="faq-accordion">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item ${openIndex === index ? 'active' : ''}`}
            >
              <button 
                className="faq-question"
                onClick={() => toggleFAQ(index)}
              >
                <span>{faq.question}</span>
                <ChevronDown 
                  className={`faq-icon ${openIndex === index ? 'rotate' : ''}`} 
                  size={20} 
                />
              </button>
              <div className={`faq-answer ${openIndex === index ? 'open' : ''}`}>
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewFAQSection;
